// extracted by mini-css-extract-plugin
export default {"div-messages-info":"EditorField_div-messages-info__aCCU5"};